import i18next from 'i18next';
import { useMutation } from 'react-query';
import { sleep } from '../../../config/utils/genericHelpers';
import { TransportType } from '../../../interfaces/myDataDelivery.interface';
import { GenericResponse } from '../../../interfaces/shared.interface';
import { TRANSIT_STATUS_REFRESH_DELAY_MS } from '../../../services/utils/deliveryStatusUtils';
import { setToast } from '../../../store/core/coreSlice';
import { store } from '../../../store/store';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';

interface DataDTO {
  mark?: string | number;
  qrUrl: string;
  vehicleNumber: string;
  transportType: TransportType;
  pNumber?: string;
  latitude?: string;
  longitude?: string;
}

const registerTransferService = async (data: DataDTO): Promise<GenericResponse> => {
  const resp = await apiRQ.post<GenericResponse>('/delivery/register-transfer', { data });

  // myDATA needs a moment to register the action before GetDeliveryNoteStatus reflects it -- wait
  // here (keeping the mutation, and any `isLoading`-driven spinner, active) before returning, so the
  // status refetch below doesn't race a stale read
  if (resp.data?.success) await sleep(TRANSIT_STATUS_REFRESH_DELAY_MS);

  return resp.data;
};

export const useMutateRegisterTransfer = () => {
  return useMutation(registerTransferService, {
    onSuccess: (data, variables) => {
      if (data?.success) {
        store.dispatch(setToast({ value: { show: true, msg: i18next.t('DELIVERY.SUCCESSFUL_TRANSFER') } }));
        // When the mark is already known, the parent screen owns the status display via
        // useDeliveryStatusByMark -- invalidate that instead of also firing a qrUrl-based fetch
        if (variables.mark) {
          queryClient?.invalidateQueries({ queryKey: ['useDeliveryStatusByMark', String(variables.mark)] });
        } else {
          queryClient?.invalidateQueries({ queryKey: ['useDeliveryStatusByQrUrl', variables.qrUrl] });
        }
      }
    },
  });
};
